import getColor from './get_color.js'

riot.tag2('munis-map-legend', '<span class="{getClass(\'annotation\')}">Anteil der <strong>ausschließlich</strong> geringfügig Beschäftigten am Wohnort</span> <ul class="{getClass(\'list\')}"> <li each="{ticks}" class="{parent.getClass(\'list-item\')}"> {value}&nbsp;%<span riot-style="background-color:{color};"></span> </li> </ul>', '', 'class="{getClass()}"', function(opts) {

  this.ticks = getColor.quantiles().map(q => {
    return {
      color: getColor(q),
      value: Math.round(q * 10) / 10
    }
  })

});



// WEBPACK FOOTER //
// ./src/components/munis-map/munis-map-legend.tag